// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"026a5a90","8":"af3c765a","12":"f93cb8f9","143":"8dc6cea8","260":"8a095001","293":"4874fc28","488":"75e10112","510":"bea2bee8","534":"8d0d19dc","566":"d5d32d55","596":"5e48fff4","627":"99fbfc27","715":"33a3f07f","725":"e05078e4","812":"6001e44b","922":"6b735252"}[chunkId] + ".chunk.js";
};